import React, { ReactElement } from 'react'

export type TipPosition = 'right' | 'left' | 'top' | 'bottom'

export interface ITipProps {
  tip: string
  position: TipPosition
  element?: ReactElement | string
}

const Tip = ({ tip, position, element }: ITipProps) => (
  <i
    className={'csas-tooltip--medium csas-tooltip--darker csas-tooltip--' + position}
    tooltip-positioner=''
    aria-label={tip}
    data-testid='tip-component'
  >
    {element ? element : '?'}
  </i>
)

export default Tip
